
import Vue from 'vue'
import AdminIcon from '@/assets/svgs/admin_icon.svg?inline'
import LearnIcon from '@/assets/svgs/learn_icon.svg?inline'
import HamburgerIcon from '@/assets/svgs/hamburger_icon.svg?inline'
import FaceMaskIcon from '@/assets/svgs/face_mask_icon.svg?inline'
import ExitDoorIcon from '@/assets/svgs/exit_door_icon.svg?inline'

export default Vue.extend({
  name: 'Header',
  computed: {
    hideForMvp (): boolean {
      return this.$route.path.includes('profile')
    },
  },
  components: {
    AdminIcon,
    LearnIcon,
    HamburgerIcon,
    FaceMaskIcon,
    ExitDoorIcon,
  },
  props: {
    hasHamburgerMenu: {
      type: Boolean,
      required: false,
      default: true
    },
    isMasqueradingReadOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  methods: {
    goBackToSummitAdminPage: function () {
      const userPath = this.$route.query.summitUserId ? '/user/' + this.$route.query.summitUserId : ''
      window.location.href = process.env.VUE_APP_SUMMIT_ADMIN_URL! + userPath
    }
  }
})
